import { render } from "./Withdraw.vue?vue&type=template&id=530c993a"
import script from "./Withdraw.vue?vue&type=script&lang=js"
export * from "./Withdraw.vue?vue&type=script&lang=js"

import "./Withdraw.vue?vue&type=style&index=0&id=530c993a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__